import { motion } from "framer-motion";
import { Star } from "lucide-react";

export default function Reviews() {
  return (
    <section
      id="avaliacoes"
      data-testid="reviews-section"
      className="relative py-24 md:py-32 bg-[#0A0A0A] overflow-hidden"
    >
      <div className="absolute inset-0 bg-noise opacity-[0.025]" />
      <div className="absolute left-1/2 -translate-x-1/2 top-0 w-[700px] h-[300px] bg-red-600/8 blur-[150px] rounded-full" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Heading */}
        <div className="text-center mb-16">
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="text-xs uppercase tracking-[0.35em] text-red-500 font-bold mb-6 flex items-center justify-center gap-3"
          >
            <span className="w-8 h-px bg-red-500" />
            Avaliações
            <span className="w-8 h-px bg-red-500" />
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="font-display text-4xl md:text-5xl lg:text-6xl font-black uppercase leading-[1] tracking-tighter text-white"
          >
            Clientes que <span className="text-red-600">confiam</span>
            <br />
            na Full Force.
          </motion.h2>

          {/* Rating Block */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="mt-10 inline-flex items-center gap-6 bg-zinc-900/40 backdrop-blur-md border border-zinc-800 px-8 py-5"
            data-testid="reviews-rating-block"
          >
            <div className="text-left">
              <p className="font-display text-5xl font-black text-white">5.0</p>
              <p className="text-xs text-zinc-500 uppercase tracking-widest mt-1">Google</p>
            </div>
            <div className="h-12 w-px bg-zinc-800" />
            <div className="text-left">
              <div className="flex gap-1 mb-1">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={18} className="fill-red-500 text-red-500" />
                ))}
              </div>
              <p className="text-xs text-zinc-400 uppercase tracking-widest mt-1">Avaliação Google</p>
            </div>
          </motion.div>
        </div>

      </div>
    </section>
  );
}
